
import { locale } from './globals.js';
import { getOffset, throttle, viewport } from './toolbox.js';

const arrowBtn = function (dir) {
  return `<button class="arrow ${dir} custom">
    <i class="fal fa-chevron-circle-${locale[dir]} icon"></i>
  </button>`
}
class TabBar {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.id = this.el.getAttribute('id');
    this.list = this.el.querySelector('[data-tab-list]');
    this.hasSlideControls = this.el.hasAttribute('data-slide-controls');
    this.freeScroll = this.el.hasAttribute('data-free-scroll');
    this.rtl = (locale.dir == 'rtl');
    this.tabAlign = (locale.dir == 'ltr') ? 'left' : 'right';
    this.updateEvent = new Event('tab-content-update');
    this.initSlider();
    this.initControls();
  }
  initSlider () {
    let self = this;
    this.flkty = new Flickity(this.list, {
      cellAlign: this.tabAlign,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      rightToLeft: this.rtl,
      freeScroll: this.freeScroll/*,
      friction: 0.15,
      selectedAttraction: 0.01*/
    });
    this.dragged = false;
    this.flkty.on('change', () => {
      this.updatePagerControls();
    });
    if(this.hasSlideControls) {
      this.flkty.on('scroll', throttle( (progress) => {
        self.slideState = progress;
        self.updateSlideControls();
      }, 50) );
      this.flkty.on('settle', () => {
        this.updateSlideControls();
      });
    }
    this.flkty.on('dragStart', () => { this.dragged = true; })
    this.flkty.on('dragEnd', () => {
      setTimeout( () => { this.dragged = false; }, 50);
    })
    this.flkty.cells.forEach( (cell, index) => {
      cell.element.setAttribute('data-index', index);
      cell.element.addEventListener('click', function(event) {
        if(this.classList.contains('.active')) return;
        self.activateTab(this, event);
      })
    })

    // initialize an active tab
    let defaultIndex = 0; // default is the first tab
    let activeTab = this.el.querySelector('.tab.active'); // if the dom has one, activate that
    if(activeTab) {
      this.activateTab(activeTab, false, true);
    } else {
      defaultIndex = this.checkHash(); // if our tabs have the hash, use that tab
      if(defaultIndex < 0) { defaultIndex = 0} // otherwise 0
      this.activateTab(this.flkty.cells[defaultIndex].element, false, true);
    }
    window.addEventListener('hashchange', (event) => {
      let hashIndex = this.checkHash();
      if (hashIndex > -1) this.activateTab(this.flkty.cells[hashIndex].element);
    })
  }
  // activateIndex(index) {
  //   this.activateTab(this.flkty.cells[index], false);
  // }
  checkHash (hash) {
    let index = -1;
    if(hash == undefined) hash = location.hash;
    this.flkty.cells.forEach((cell, i) => {
      if(hash == cell.element.getAttribute('href')) {
        index = i;
      }
    })
    return index;
    // if(index > -1) {
    //   this.activateIndex(index);
    //   if(this.parentSlide) {
    //     $(this.parentSlide).trigger('initslide.carousel');
    //   }
    // }
  }
  activateTab(tab, event, init) {
    if (!init) {
      // skip these for initial setup
      if(!tab) return;
      if (tab.classList.contains('active')) return;
      if (this.dragged) { this.dragged = false; return; }
      let prevTab = this.el.querySelector('.tab.active');
      if (prevTab) prevTab.classList.remove('active')
    }

    tab.classList.add('active'); // activate tab
    this.currentIndex = parseInt(tab.getAttribute('data-index')); //save active index
    this.flkty.select(this.currentIndex); // select flkty cell to slide in position

    let tabHref = tab.getAttribute('href'); // check if #href for content
    if(tabHref && tabHref.startsWith('#') && tabHref.length > 1) {
      if(event) event.preventDefault(); 
      this.updateHash(tabHref);
      this.activateContent(tabHref.slice(1));
    }
    
  }
  updateHash (hash) {
    // if (index == undefined) index = this.current;
    // let hash = this.tabs[index].getAttribute('href');
    if (location.hash == hash) {
      return;
    }
    if(history && history.pushState) {
      history.pushState(null, null, hash);
    } else {
      location.hash = hash;
    }
  }
  activateContent(tabHref) {
    let contents = Array.from(document.querySelectorAll(`[data-tab-content=${tabHref}]`));
    if (contents.length < 1) return;
    contents.forEach((content) => {
      let prevContent = content.parentElement.querySelector('.tab-content.active');
      if(prevContent) {
        prevContent.classList.remove('active');
        prevContent.dispatchEvent(this.updateEvent);
      }
      content.classList.add('active');
      content.dispatchEvent(this.updateEvent);
    });
  }

  initControls () {
    // slide controls
    if(this.hasSlideControls) {
      this.slideControls = document.createElement('div');
      this.slideControls.classList.add('tab-controls');
      this.slideControls.innerHTML = arrowBtn('prev') + arrowBtn('next');
      this.el.insertBefore(this.slideControls, this.list);
      requestAnimationFrame(this.initSlideControls.bind(this));
    }
    // pre-defined pager controls
    let pagers = Array.from(document.querySelectorAll(`[data-tab-pager=${this.id}]`));
    pagers.forEach((pager, index) => {
      pager.innerHTML = arrowBtn('prev') + arrowBtn('next');
      requestAnimationFrame(() => {
        this.initPagerControls(pager); 
      });
    });
  }
  initPagerControls(pager) {
    pager.querySelector('.arrow.prev').addEventListener('click', () => {
      if(this.flkty.cells[this.currentIndex - 1])
        this.activateTab(this.flkty.cells[this.currentIndex - 1].element);
      else 
        this.activateTab(this.flkty.cells[this.flkty.cells.length - 1].element);
    })
    pager.querySelector('.arrow.next').addEventListener('click', () => {
      if(this.flkty.cells[this.currentIndex + 1])
        this.activateTab(this.flkty.cells[this.currentIndex + 1].element);
      else 
        this.activateTab(this.flkty.cells[0].element);
    })
  }
  updatePagerControls() {

  }
  initSlideControls () {
    this.slideControls.querySelector('.arrow.prev').addEventListener('click', () => {
      this.slide(20);
    })
    this.slideControls.querySelector('.arrow.next').addEventListener('click', () => {
      this.slide(-20);
    })
  }
  slide(offset) {
    this.flkty.applyForce(offset);
    this.flkty.startAnimation();
    this.flkty.dragEnd();
  }
  updateSlideControls () {
    if (isNaN(this.slideState) || this.slideState === Infinity || this.slideState === -Infinity ) {
      this.slideControls.querySelector('.arrow.prev').classList.add('disabled');
      this.slideControls.querySelector('.arrow.next').classList.add('disabled');
    } else {
      if(this.slideState < 0.05) {
        this.slideControls.querySelector('.arrow.prev').classList.add('disabled');
        this.list.classList.remove('overflown-prev');
      } else {
        this.slideControls.querySelector('.arrow.prev').classList.remove('disabled');
        this.list.classList.add('overflown-prev');
      }
      if(this.slideState > 0.95) {
        this.slideControls.querySelector('.arrow.next').classList.add('disabled');
        this.list.classList.remove('overflown-next');
      } else {
        this.slideControls.querySelector('.arrow.next').classList.remove('disabled');
        this.list.classList.add('overflown-next');
      }
    }
  }
}
export default function () {
  Array.from(document.querySelectorAll('[data-tab-bar]')).forEach( (item, index) => {
    new TabBar(item, index);
  });
}
